import { formatUsd, stripTrailingZeros } from 'src/constants/ConversionUtils'
import BlockchainIcon from 'src/assets/components/BlockchainIcon'
import 'src/components/shared/TransferInfo.css'
import { PayloadData } from 'src/constants/DataModels'
import { ExplorerAddressLink } from 'src/components/shared/ExplorerAddressLink'
import TokenIcon from 'src/assets/components/TokenIcon'
import React from 'react'
import { getAssetURL } from 'src/constants/BlockchainConstants'
import { useAppSelector } from 'src/store/store'

type blockchainProps = {
  source_blockchain: string
  destination_blockchain: string
  payload: PayloadData
}

export const TransferInfo = ({
                               source_blockchain,
                               destination_blockchain,
                               payload
                             }: blockchainProps) => {
  const network = useAppSelector((state) => state.NetworkReducer.network)
  if (!payload) {
    return null
  }
  const {
    sender,
    transfer_receiver,
    transfer_value_usd,
    transfer_symbol,
    transfer_amount_human,
    transfer_denom,
  } = payload
  const shouldShowTransferInfo = !!transfer_amount_human
    && Number(transfer_amount_human) >= 0
  if (!shouldShowTransferInfo) {
    return null
  }
  const explorerUrl = getAssetURL('carbon', transfer_denom, network)
  return (
    <div className={'transfer-info'}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <BlockchainIcon blockchain={source_blockchain} className="blockchain-icon" />
        <ExplorerAddressLink blockchain={source_blockchain} address={sender}
                             shouldTruncate={true} className={'address-link-transfer-info'}
        />
        <span>➔</span>
        <BlockchainIcon blockchain={destination_blockchain} className="blockchain-icon" />
        <ExplorerAddressLink blockchain={destination_blockchain} address={transfer_receiver}
                             shouldTruncate={true} className={'address-link-transfer-info'}
        />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <TokenIcon token={transfer_symbol} className="token-icon"
        />
        <div className={'transfer-amount'}>
          {stripTrailingZeros(transfer_amount_human)}
        </div>
        {
          explorerUrl ? (
            <a href={explorerUrl} className={`link`} target="_blank" rel="noreferrer"
            >{transfer_symbol}</a>
          ) : transfer_symbol
        }


        <small
          className="usd-badge"
        >({formatUsd(transfer_value_usd)})</small>
      </div>
    </div>
  )
}
